import { render, staticRenderFns } from "./FormCreateUser.vue?vue&type=template&id=3c4d5ef2&"
import script from "./FormCreateUser.vue?vue&type=script&lang=ts&"
export * from "./FormCreateUser.vue?vue&type=script&lang=ts&"
import style0 from "./FormCreateUser.vue?vue&type=style&index=0&id=3c4d5ef2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports